<template>
  <div class="rebate-page common-bg">
    <div class="page-header">
      <div class="header-title"></div>
      <div class="calculator-link" @click="showCalculator = true">
        <van-icon name="calculator-o" size="16" color="#DFB372" />
        <span>佣金模拟计算器</span>
      </div>
    </div>

    <div class="content-area">
      <div class="game-list">
        <div class="game-item" v-for="(item, index) in gameTypes" :key="index" :class="{ active: activeGame === index }" @click="activeGame = index">
          <div class="game-icon-wrap" v-html="item.iconSvg"></div>
          <span class="game-name">{{ item.name }}</span>
        </div>
      </div>

      <div class="table-area">
        <div class="table-header">
          <div class="th">有效人数 <van-icon name="question-o" size="12" color="#888" /></div>
          <div class="th">业绩<span class="th-sub">（单位：个）</span></div>
          <div class="th">返佣金额<span class="th-sub">（比例）</span></div>
        </div>
        <div class="table-row" v-for="(row, index) in tableData" :key="index">
          <div class="td">{{ row.count }}</div>
          <div class="td">{{ row.amount }}</div>
          <div class="td gold">
            {{ row.commission }}
            <div class="td-sub">({{ row.rate }})</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 佣金模拟计算器弹窗 -->
    <div class="calc-overlay" v-if="showCalculator" @click="showCalculator = false"></div>
    <div class="calc-popup" v-if="showCalculator">
      <div class="calc-header">
        <van-icon name="calculator-o" size="18" color="#DFB372" />
        <span>佣金模拟计算器</span>
      </div>
      <div class="calc-body">
        <div class="calc-item">
          <div class="calc-label">游戏类型</div>
          <div class="calc-select" @click="showGameSelect = !showGameSelect">
            <span :class="{ placeholder: !selectedGame }">{{ selectedGame || '请选择' }}</span>
            <van-icon name="arrow-down" size="14" color="#888" />
          </div>
          <div class="select-dropdown" v-if="showGameSelect">
            <div class="select-option" v-for="(item, index) in gameTypes" :key="index" :class="{ active: selectedGame === item.name }" @click="selectedGame = item.name; showGameSelect = false">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="calc-item">
          <div class="calc-label">有效人数</div>
          <input v-model="calcForm.count" type="number" placeholder="0" class="calc-input" />
        </div>
        <div class="calc-item">
          <div class="calc-label">有效投注</div>
          <input v-model="calcForm.bet" type="number" placeholder="0.00" class="calc-input" />
        </div>
        <div class="calc-btn" @click="calcCommission">计算佣金</div>
        <div class="calc-divider"></div>
        <div class="calc-result-title">计算结果</div>
        <div class="calc-result">
          <div class="result-item">
            <span class="result-label">返佣比例</span>
            <span class="result-value">{{ calcResult.rate || '-' }}</span>
          </div>
          <div class="result-item">
            <span class="result-label">预计佣金</span>
            <span class="result-value">{{ calcResult.commission || '-' }}</span>
          </div>
        </div>
      </div>
      <div class="calc-close" @click="showCalculator = false">
        <van-icon name="cross" size="24" color="#fff" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promoteRebate',
  data() {
    return {
      activeGame: 0,
      showCalculator: false,
      showGameSelect: false,
      selectedGame: '',
      calcForm: {
        count: '',
        bet: '',
      },
      calcResult: {
        rate: '',
        commission: '',
      },
      gameTypes: [
        {
          name: '电子',
          iconSvg: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="6" width="24" height="28" rx="3" stroke="currentColor" stroke-width="2"/><line x1="8" y1="14" x2="32" y2="14" stroke="currentColor" stroke-width="2"/><line x1="8" y1="22" x2="32" y2="22" stroke="currentColor" stroke-width="2"/><line x1="8" y1="30" x2="32" y2="30" stroke="currentColor" stroke-width="2"/><circle cx="14" cy="10" r="2" fill="currentColor"/><circle cx="20" cy="10" r="2" fill="currentColor"/><circle cx="26" cy="10" r="2" fill="currentColor"/></svg>',
        },
        {
          name: '棋牌',
          iconSvg: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="10" width="16" height="22" rx="2" stroke="currentColor" stroke-width="2"/><rect x="18" y="6" width="16" height="22" rx="2" stroke="currentColor" stroke-width="2"/><text x="12" y="24" font-size="10" fill="currentColor" text-anchor="middle" font-weight="bold">A</text><text x="28" y="20" font-size="10" fill="currentColor" text-anchor="middle" font-weight="bold">K</text></svg>',
        },
        {
          name: '捕鱼',
          iconSvg: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 20C8 20 14 12 22 14C30 16 34 20 34 20C34 20 30 24 22 26C14 28 8 20 8 20Z" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="28" cy="19" r="2" fill="currentColor"/><path d="M6 16L10 20L6 24" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
        },
        {
          name: '真人',
          iconSvg: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="14" r="6" stroke="currentColor" stroke-width="2"/><path d="M10 34C10 28 14 24 20 24C26 24 30 28 30 34" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="20" cy="14" r="2" fill="currentColor"/></svg>',
        },
        {
          name: '体育',
          iconSvg: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="14" stroke="currentColor" stroke-width="2"/><path d="M20 6C20 6 26 14 26 20C26 26 20 34 20 34" stroke="currentColor" stroke-width="1.5"/><path d="M20 6C20 6 14 14 14 20C14 26 20 34 20 34" stroke="currentColor" stroke-width="1.5"/><line x1="6" y1="20" x2="34" y2="20" stroke="currentColor" stroke-width="1.5"/></svg>',
        },
        {
          name: '电竞',
          iconSvg: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 18L20 8L30 18" stroke="currentColor" stroke-width="2" fill="none"/><path d="M10 22L20 32L30 22" stroke="currentColor" stroke-width="2" fill="none"/><line x1="20" y1="8" x2="20" y2="32" stroke="currentColor" stroke-width="1.5"/></svg>',
        },
      ],
      tableData: [
        { count: 1, amount: '0.00', commission: '0.00', rate: '0.50%' },
        { count: 1, amount: '1,000,000.00', commission: '6,000.00', rate: '0.60%' },
        { count: 1, amount: '2,000,000.00', commission: '14,000.00', rate: '0.70%' },
        { count: 1, amount: '5,000,000.00', commission: '45,000.00', rate: '0.90%' },
      ],
    };
  },
  methods: {
    calcCommission() {
      if (!this.selectedGame) {
        this.$notify({ type: 'danger', message: '请选择游戏类型' });
        return;
      }
      const count = parseFloat(this.calcForm.count) || 0;
      const bet = parseFloat(this.calcForm.bet) || 0;
      let rate = 0.005;
      if (bet >= 5000000) rate = 0.009;
      else if (bet >= 2000000) rate = 0.007;
      else if (bet >= 1000000) rate = 0.006;
      this.calcResult.rate = (rate * 100).toFixed(2) + '%';
      this.calcResult.commission = (bet * rate).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.rebate-page {
  min-height: 100vh;
  background: #1E1F24;
  padding-bottom: 1rem;

  .page-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0.2rem 0.15rem;

    .calculator-link {
      display: flex;
      align-items: center;
      gap: 0.06rem;
      font-size: 0.3rem;
      color: #DFB372;
    }
  }

  .content-area {
    display: flex;
    padding: 0 0.15rem;
    gap: 0.15rem;
  }

  .game-list {
    width: 1.2rem;
    flex-shrink: 0;

    .game-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.15rem 0.1rem;
      margin-bottom: 0.1rem;
      background: #292A2C;
      border-radius: 0.12rem;
      border: 1px solid #3B3C3D;

      &.active {
        background: linear-gradient(90deg, #f3ca8e 0%, #dfb372 100%);
        border-color: #DFB372;

        .game-name {
          color: #333;
        }
      }

      .game-icon-wrap {
        width: 0.6rem;
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.06rem;
        color: #888;

        svg {
          width: 0.5rem;
          height: 0.5rem;
        }
      }

      &.active .game-icon-wrap {
        color: #333;
      }

      .game-name {
        font-size: 0.3rem;
        color: #888;
      }
    }
  }

  .table-area {
    flex: 1;
    min-width: 0;

    .table-header {
      display: flex;
      align-items: center;
      padding: 0.15rem 0.1rem;
      background: #292A2C;
      border-radius: 0.12rem 0.12rem 0 0;
      border: 1px solid #3B3C3D;
      border-bottom: none;

      .th {
        flex: 1;
        font-size: 0.3rem;
        color: #fff;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.04rem;

        .th-sub {
          font-size: 0.3rem;
          color: #888;
        }
      }
    }

    .table-row {
      display: flex;
      align-items: center;
      padding: 0.15rem 0.1rem;
      background: #292A2C;
      border: 1px solid #3B3C3D;
      border-top: none;

      &:last-child {
        border-radius: 0 0 0.12rem 0.12rem;
      }

      .td {
        flex: 1;
        font-size: 0.3rem;
        color: #fff;
        text-align: center;

        &.gold {
          color: #DFB372;
          font-weight: bold;

          .td-sub {
            font-size: 0.3rem;
            color: #DFB372;
            font-weight: normal;
          }
        }
      }
    }
  }

  .calc-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 299;
  }

  .calc-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 6rem;
    background: #292A2C;
    border-radius: 0.2rem;
    z-index: 300;
    padding: 0.3rem;

    .calc-header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.1rem;
      font-size: 0.35rem;
      color: #fff;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }

    .calc-body {
      .calc-item {
        margin-bottom: 0.2rem;

        .calc-label {
          font-size: 0.3rem;
          color: #fff;
          margin-bottom: 0.1rem;
        }

        .calc-select {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #1E1F24;
          border: 1px solid #3B3C3D;
          border-radius: 0.12rem;
          padding: 0.18rem 0.2rem;
          font-size: 0.3rem;
          color: #fff;
          position: relative;

          .placeholder {
            color: #666;
          }
        }

        .select-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: #1E1F24;
          border: 1px solid #3B3C3D;
          border-radius: 0.08rem;
          z-index: 310;
          margin-top: 0.04rem;

          .select-option {
            padding: 0.18rem 0.2rem;
            font-size: 0.3rem;
            color: #fff;
            text-align: center;

            &.active {
              color: #DFB372;
            }
          }
        }

        .calc-input {
          width: 100%;
          background: #1E1F24;
          border: 1px solid #3B3C3D;
          border-radius: 0.12rem;
          padding: 0.18rem 0.2rem;
          font-size: 0.3rem;
          color: #fff;
          box-sizing: border-box;
          outline: none;

          &::placeholder {
            color: #666;
          }
        }
      }

      .calc-btn {
        width: 100%;
        padding: 0.22rem 0;
        background: #555;
        border-radius: 0.5rem;
        text-align: center;
        font-size: 0.35rem;
        color: #fff;
        margin-top: 0.1rem;
      }

      .calc-divider {
        height: 1px;
        background: #3B3C3D;
        margin: 0.25rem 0;
      }

      .calc-result-title {
        text-align: center;
        font-size: 0.35rem;
        color: #fff;
        font-weight: bold;
        margin-bottom: 0.15rem;
      }

      .calc-result {
        display: flex;
        justify-content: space-between;

        .result-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .result-label {
            font-size: 0.3rem;
            color: #888;
            margin-bottom: 0.06rem;
          }

          .result-value {
            font-size: 0.35rem;
            color: #DFB372;
            font-weight: bold;
          }
        }
      }
    }

    .calc-close {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/Rebate.vue